import { EventEmitter, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { LocalStorage } from 'ngx-webstorage';
import { BehaviorSubject } from 'rxjs';

import { AOService } from './ao.service';
import { AOAuthProviderInterface } from './ao-auth-provider.interface';

// @dynamic

@Injectable({
  providedIn: 'root'
})
export class AOAuthService {

  @LocalStorage('user') private _user: any;

  @LocalStorage('redirect') private _redirect: string;

  private _redirect_default = '/';

  private _provider: AOAuthProviderInterface;

  public static _onLogin: EventEmitter<void> = new EventEmitter<any>();

  public static _onLogout: EventEmitter<void> = new EventEmitter<void>();

  public static _onChange: BehaviorSubject<any>;

  // -------------------------------------------------------------------------------------------------------------------

  constructor(
    private _nav: NavController,
    private _ao: AOService,
  ) {
    AOAuthService._onChange = new BehaviorSubject<any>(this.user());
  }

  // -------------------------------------------------------------------------------------------------------------------

  provider(provider: AOAuthProviderInterface = null): AOAuthProviderInterface | this {
    if (provider == null) {
      return this._provider;
    }

    this._provider = provider;

    return this;
  }

  // -------------------------------------------------------------------------------------------------------------------

  setRedirect(redirect) {
    this._redirect = redirect;
    return this;
  }

  redirect = () => this._redirect;

  // -------------------------------------------------------------------------------------------------------------------

  setUser(user) {
    this._user = user;

    this.onChange().next(this._user);

    return this;
  }

  user = () => this._user;

  // -------------------------------------------------------------------------------------------------------------------

  isUser = () => !!this._user;

  isGuest = () => !this._user;

  id = () => this.isUser() ? this.user().id : null;

  name = () => this.isUser() ? this.user().name : null;

  email = () => this.isUser() ? this.user().email : null;

  image = () => this.isUser() ? this.user().image : null;

  verified = () => this.isUser() ? this.user().verified : null;

  permitions = () => this.isUser() ? this.user().permitions : null;

  // -------------------------------------------------------------------------------------------------------------------

  onLogin = () => AOAuthService._onLogin;

  onLogout = () => AOAuthService._onLogout;

  onChange = () => AOAuthService._onChange;

  // -------------------------------------------------------------------------------------------------------------------

  login(data: any): Promise<any> {
    return this._ao.wait(this.provider().login(data)).then((user) => {

      this.setUser(user);
      this.onLogin().emit();

      const redirect = this._redirect && this._redirect !== '/login'
        ? this._redirect
        : this._redirect_default;

      this._redirect = null;

      return this._nav.navigateRoot(redirect);

    });
  }

  logout(): Promise<any> {
    return this._ao.wait(this.provider().logout()).then(() => {

      this.setUser(null);
      this.onLogout();

      return this._nav.navigateRoot('/login');

    });
  }

  update(data: any): Promise<any> {
    return this._ao.wait(this.provider().update(data));
  }

  updatePassword(data: any): Promise<any> {
    return this._ao.wait(this.provider().updatePassword(data));
  }

  forgetPassword(data: any): Promise<any> {
    return this._ao.wait(this.provider().forgetPassword(data));
  }

  resetPassword(data: any): Promise<any> {
    return this._ao.wait(this.provider().resetPassword(data));
  }

}
